export const CONFERENCE = {
  name: "BioInnovate 2026",
  tagline: "Shaping the Future of Biotechnology",
  dates: "July 16–18, 2026",
  countdownTarget: "2026-07-16T09:00:00+05:30",
  venue: "Kalasalingam Academy of Research and Education (KARE), Krishnankoil, Tamil Nadu, India",
  registerUrl: "https://docs.google.com/forms/d/e/1FAIpQLSekpkRrf1WCetTIkMcDDzRxDHhQwuEq9VkT-Fb_jxYUZjf3tw/viewform",
  registerEmbedUrl: "https://docs.google.com/forms/d/e/1FAIpQLSekpkRrf1WCetTIkMcDDzRxDHhQwuEq9VkT-Fb_jxYUZjf3tw/viewform?embedded=true",
  email: "bioinnovate2026@klu.ac.in",
  website: "https://www.kalasalingam.ac.in/site/bioinnovate/",
  abstractTemplate: "https://www.kalasalingam.ac.in/wp-content/uploads/2026/05/Abstract-Template.pdf",
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "AI Workshop", href: "#ai-workshop" },
  { label: "Startup Track", href: "#startup-track" },
  { label: "Speakers", href: "#speakers" },
  { label: "Dates", href: "#dates" },
  { label: "Contact", href: "#contact" },
];

export const PARTNERS = ["KARE", "Arizona State University", "IAAM", "Blude TechX"];

export const ABOUT = {
  body: "BioInnovate 2026, organized by Kalasalingam Academy of Research and Education in association with Arizona State University and the Indian Association of Applied Microbiologists (IAAM), is a multidisciplinary platform for emerging innovations in biotechnology. Across three days, it explores advances in genomics, bioengineering, synthetic biology, biopharmaceuticals, and AI-driven life sciences, bringing together leading experts from India and abroad and giving students and young researchers a stage to share work and gain insight into the frontiers of biotechnology and allied fields.",
  stats: [
    { value: "3", label: "Days" },
    { value: "15+", label: "Global Speakers" },
    { value: "India × USA", label: "Collaboration" },
    { value: "₹ Prize", label: "Pitch + Hackathon" },
  ],
};

export const THRUST_AREAS = [
  "Genomics, Gene Editing & Precision Medicine",
  "Artificial Intelligence in Biotechnology",
  "Regenerative Medicine, Stem Cells & Tissue Engineering",
  "Microbiome in Health & Disease",
  "Biomaterials for Healthcare & Industry",
  "Vaccine Technology & Immunotherapy",
  "Industrial & Environmental Biotechnology",
  "Biotech for Climate Action & Sustainability",
  "Industrial Enzymes & Bioprocess Optimization",
  "Biofuels, Bioplastics & Circular Bioeconomy",
  "Agricultural Biotechnology & Smart Farming",
  "Biotech Startups & Innovation Ecosystems",
  "Future Workforce & Skill Development",
  "Women Leadership in Biotechnology",
];

export const EXPECT = [
  { title: "Invited Lectures", desc: "Talks by renowned experts from around the world." },
  { title: "Pre-conference Workshops", desc: "Hands-on sessions led by eminent scientists." },
  { title: "Oral & Poster Presentations", desc: "A stage for students and young researchers." },
  { title: "BioLaunch Arena", desc: "A smart pitch competition for innovative ideas." },
  { title: "CodeRx", desc: "A dynamic hackathon focused on medical coding." },
  { title: "Skill Labs", desc: "Patents, Regulatory Documentation, and AI tools." },
  { title: "Panel Discussions", desc: "Startup funding and the role of AI in biotechnology." },
  { title: "BioRhythms", desc: "A fusion of science and art through MEMS, music, and dance." },
];

export const AI_WORKSHOP = {
  eyebrow: "AI Landscape · Curated by Blude TechX",
  heading: "The Biological AI Builder's Workshop",
  subhead: "Do research in minutes. Build software with no code. All in one afternoon.",
  pullQuote: "Walk in not knowing how to code. Walk out having built a working tool.",
  intro: "A 3-hour, fully hands-on workshop that turns researchers, students, and faculty into AI-native builders. No coding experience needed. If you can type a sentence, you can do this. Bring a laptop (fully charged).",
  arc: [
    { step: "01", title: "Research", desc: "Find a publishable research gap in minutes." },
    { step: "02", title: "Build", desc: "Ship a working tool, live, with no code." },
    { step: "03", title: "Career", desc: "Leave with a personal 30-day AI plan." },
  ],
  checklist: [
    "A research-gap brief on your own topic",
    "A working tool you built live",
    "A 3-line pitch for your idea",
    "A personal 30-day AI plan",
    "The “Top 22 AI Workflows for Biosciences” guide",
    "The 2026 researcher tool stack",
  ],
  details: "3 hours · Hands-on · Bring a laptop · July 16–18, 2026 · School of Biotechnology, KARE",
};

export const STARTUP_TRACK = {
  eyebrow: "Startup Landscape Track · Curated by Blude TechX",
  heading: "Turn breakthroughs into companies and careers.",
  subhead: "Sessions that take your biotech or healthcare research from lab bench to funded venture, judged by founders, bankers, and investors.",
  prizeCallout: "Cash Prize + Mentorship for Winners. The Pitch Competition winner takes home a cash prize and dedicated mentorship to incorporate, navigate regulatory pathways, and build their life-science venture.",
  sessions: [
    {
      num: "01",
      title: "Pitch Your Idea",
      desc: "Day 1: a hands-on workshop to shape your research into an investable biotech or healthcare pitch. Day 2: a live Pitch Competition judged by real life-science founders and investors. Winner: cash prize + mentorship for registration & development + incubation consideration.",
    },
    {
      num: "02",
      title: "Financials with Bankers",
      desc: "A working panel with bankers and funding experts on biotech-specific capital (BIRAC, DBT and government schemes, grants, and loans) and how to manage money through long R&D and regulatory timelines.",
    },
    {
      num: "03",
      title: "Founders & Mentors Closed-Door",
      desc: "Selected teams earn a closed-door session with life-science founders and MedTech/HealthTech mentors: candid guidance on clinical validation, regulatory strategy, IP, and reaching your first pilot or customer.",
    },
  ],
  whoItsFor: "Open to students and research scholars across biotech, pharma, medical, and allied health fields. Form teams of 2–4. Individuals are welcome too. Want to lead on your campus? Become a Campus Ambassador.",
};

export const SPEAKERS = [
  { name: "Prof. K. Dharmalingam", role: "Director-Research, Aravind Medical Research Foundation, Madurai", img: "/speakers/dharmalingam.jpg" },
  { name: "Prof. A.W. Santhosh Kumar", role: "Vice Chancellor, Amity University, Mumbai", img: "/speakers/santhosh-kumar.jpg" },
  { name: "Dr. P. Sundaresan", role: "ICMR Emeritus Scientist, Aravind Medical Research Foundation, Madurai", img: "/speakers/sundaresan.jpg" },
  { name: "Dr. Shwetal Mehta", role: "Ina Levine Chair for Brain Tumor Research & Deputy Director, Ivy Brain Tumor Center, Barrow Neurological Institute, Phoenix, AZ, USA", img: "/speakers/shwetal-mehta.jpg" },
  { name: "Prof. Vel Murugan", role: "Director of Clinical Research, Biodesign Center for Personalized Diagnostics, Arizona State University, Tempe, AZ, USA", img: "/speakers/vel-murugan.jpg" },
  { name: "Prof. Richard Coico", role: "Director, Clinical & Translational Science Center, SUNY Downstate Health Sciences University, New York, USA", img: "/speakers/richard-coico.jpg" },
  { name: "Dr. Somnath Dutta", role: "Associate Professor, Indian Institute of Science, Bangalore", img: "/speakers/somnath-dutta.jpg" },
  { name: "Dr. Rameshkumar Marimuthu Ragavan", role: "Assistant Professor, Central University of Rajasthan", img: "/speakers/rameshkumar.jpg" },
  { name: "Dr. Sankar Natesan", role: "Professor & Chairperson, School of Biotechnology, Madurai Kamaraj University", img: "/speakers/sankar-natesan.jpg" },
];

export const SPEAKER_IMAGES = [
  "https://images.unsplash.com/photo-1758613654360-45f1ff78c0cf?crop=entropy&cs=srgb&fm=jpg&w=600&q=70",
  "https://images.unsplash.com/photo-1758600587839-56ba05596c69?crop=entropy&cs=srgb&fm=jpg&w=600&q=70",
  "https://images.unsplash.com/photo-1767175620484-1ed37931a0d1?crop=entropy&cs=srgb&fm=jpg&w=600&q=70",
  "https://images.unsplash.com/photo-1770058443069-e384cd001e9b?crop=entropy&cs=srgb&fm=jpg&w=600&q=70",
  "https://images.pexels.com/photos/26728094/pexels-photo-26728094.jpeg?auto=compress&w=600&q=70",
  "https://images.pexels.com/photos/7597737/pexels-photo-7597737.jpeg?auto=compress&w=600&q=70",
  "https://images.unsplash.com/photo-1767175473698-859bc73e8e64?crop=entropy&cs=srgb&fm=jpg&w=600&q=70",
  "https://images.pexels.com/photos/30468636/pexels-photo-30468636.jpeg?auto=compress&w=600&q=70",
  "https://images.pexels.com/photos/12311581/pexels-photo-12311581.jpeg?auto=compress&w=600&q=70",
  "https://images.unsplash.com/photo-1758613654360-45f1ff78c0cf?crop=entropy&cs=srgb&fm=jpg&w=600&q=70",
  "https://images.unsplash.com/photo-1758600587839-56ba05596c69?crop=entropy&cs=srgb&fm=jpg&w=600&q=70",
  "https://images.unsplash.com/photo-1767175620484-1ed37931a0d1?crop=entropy&cs=srgb&fm=jpg&w=600&q=70",
  "https://images.unsplash.com/photo-1770058443069-e384cd001e9b?crop=entropy&cs=srgb&fm=jpg&w=600&q=70",
  "https://images.pexels.com/photos/26728094/pexels-photo-26728094.jpeg?auto=compress&w=600&q=70",
  "https://images.pexels.com/photos/7597737/pexels-photo-7597737.jpeg?auto=compress&w=600&q=70",
];

export const DATES = [
  { event: "Abstract submission deadline", date: "July 10, 2026" },
  { event: "Notification of acceptance", date: "July 14, 2026" },
  { event: "Regular registration ends", date: "July 14, 2026" },
  { event: "Spot registration applies after", date: "July 14, 2026" },
  { event: "Conference", date: "July 16–18, 2026" },
];

export const FEES = {
  headers: ["Category", "Regular Registration", "Spot"],
  rows: [
    { category: "UG & PG Students", regular: "₹1,500", spot: "₹2,500" },
    { category: "Research Fellows & Post-docs", regular: "₹2,500", spot: "₹3,500" },
    { category: "Faculty / Scientist (Industry)", regular: "₹3,500", spot: "₹4,500" },
  ],
};

export const ABSTRACTS = {
  body: "Submit original, unpublished work in clear English. Abstracts: 250–300 words, Times New Roman 12pt, 1.5 spacing, .doc/.docx, structured as Background · Objectives · Methodology · Key Results · Conclusion. The presenting author must be registered. Accepted abstracts are published in the proceedings; selected papers may be invited for full-length publication.",
};

export const ORGANIZING_TEAM = [
  { role: "Chief Patrons", names: ["Dr. S. Arivalagi (Pro-Chancellor)", "Dr. S. Shasi Anand (VP)", "Mr. S. Arjun Kalasalingam (VP)"] },
  { role: "Patrons", names: ["Dr. S. Narayanan (Vice Chancellor)", "Dr. V. Vasudevan (Registrar)", "Dr. Joshua LaBaer (Executive Director, Biodesign Institute, ASU)"] },
  { role: "Organizing Chairs", names: ["Dr. K. Sundar (Dean, SBCE)", "Dr. Vel Murugan (ASU)", "Dr. M. Pallikonda Rajasekaran (Director-R&D)"] },
  { role: "Conveners", names: ["Dr. B. Vanavil", "Dr. T. Kathiresan"] },
  { role: "Organizing Secretaries", names: ["Dr. S. Ram Kumar Pandian", "Dr. S. Sheik Asraf"] },
  { role: "Joint Secretaries", names: ["Dr. K. Jyothi", "Dr. P. Priya"] },
  { role: "Treasurer", names: ["Dr. J. Kanimozhi"] },
  { role: "Industry Partners", names: ["Dr. Vigneshkumar Sekar & Dr. Deepak Venkataraman, Blude Life Science and Tech, Madurai"] },
];

export const CONTACTS = [
  { name: "Dr. S. Ram Kumar Pandian", phone: "+91 90034 40063", tel: "+919003440063" },
  { name: "Dr. S. Sheik Asraf", phone: "+91 85266 70046", tel: "+918526670046" },
  { name: "Dr. P. Priya", phone: "+91 94863 32985", tel: "+919486332985" },
];

export const ADDRESS = "The Organizing Secretaries, BioInnovate'26, Department of Biotechnology, School of Bio, Chemical and Processing Engineering, Kalasalingam Academy of Research and Education, Krishnankoil – 626126, Tamil Nadu, India.";
